import React from 'react';

import {
  Header as BaseHeader,
  HeaderContainer,
  HeaderTitle,
} from '@Calix-Commerce/design-system/components';
import calixLogoSrc from '@Calix-Commerce/design-system/assets/img/calix-logo.png';

import { ContactSupport } from './subcomponents/ContactSupport';
import { MainMenu } from './subcomponents/MainMenu';
import { Container } from 'components/layout';
import { TimedBanner } from 'components/TimedBanner';
import { CUSTOMER_OPERATIONS_EMAIL, SUPPORT_EMAIL } from 'utils/constants';

// The banner will remain active from September 29th through November 30th, 2025.
const BANNER_DATES = {
  START: '2025-09-29T00:00:00.000-04:00',
  END: '2025-11-30T23:59:59.999-08:00',
};

// Maintenance banner will be active from December 20th, 2025 through January 6th, 2026.
const MAINTENANCE_BANNER_DATES = {
  START: '2025-12-20T00:00:00.000-04:00',
  END: '2026-01-06T23:59:59.999-08:00',
};

const Header = () => {
  return (
    <>
      <BaseHeader style={{ zIndex: '5000' }}>
        <HeaderContainer>
          <img src={calixLogoSrc} alt="Calix Logo" />
          <HeaderTitle>MY CALIX STORE</HeaderTitle>
          <ContactSupport />
          <MainMenu />
        </HeaderContainer>
      </BaseHeader>
      <Container>
        <TimedBanner
          startDate={BANNER_DATES.START}
          endDate={BANNER_DATES.END}
          type="warning"
          fixed={false}
        >
          Please verify the equipment return address on the RMA email confirmation you receive. We
          have multiple return address changes in September and October 2025.
        </TimedBanner>
        <TimedBanner
          startDate={MAINTENANCE_BANNER_DATES.START}
          endDate={MAINTENANCE_BANNER_DATES.END}
          type="warning"
          fixed={false}
        >
          Our systems are undergoing annual maintenance January 1, 2026 through January 6, 2026.
          During this temporary period, there'll be limited functionality and delayed updates. If
          you have questions regarding order status please contact Calix Customer Operations (
          <a href={`mailto:${CUSTOMER_OPERATIONS_EMAIL}`}>{CUSTOMER_OPERATIONS_EMAIL}</a>), if you
          have questions regarding an RMA please contact Calix RMA team (
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>). Thank you for visiting the My
          Calix portal and we appreciate your patience!
        </TimedBanner>
      </Container>
    </>
  );
};
export { Header };
